<template>
  <div class="my_collect_topic">
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item_top" v-if="item.exhibitor">
            <div class="logo">
              <img :src="item.exhibitor.company.logo" v-if="item.exhibitor.company.logo" v-load="'oAvatar'" />
              <img v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" v-load="'oAvatar'" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <p>{{ item.exhibitor.company.nameEn }}</p>
          </div>
          <div class="item_bottom">
            <p>
              <span>{{ item.type }}</span
              >{{ item.content }}
            </p>
          </div>
          <div class="item_type item_state" style="color:#ff563a;" v-if="item.auditState == -1">
            <div class="state0" style="color:#ff563a;">Audit failure</div>
            <div class="state_no">
              <span @click.stop="delStateNoSupply(item.id)">Delete</span>
              <div @click.stop="reEdit(item)">Edit</div>
            </div>
          </div>
          <div class="item_type" style="color:#ff9752;" v-if="item.auditState == 0">Under review</div>
          <div class="item_type" v-if="item.auditState == 1">No reply</div>
        </div>

        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>

    <!-- 预约洽谈 -->
    <order ref="order" @finish="getList"></order>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { List } from "vant";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import order from "@components/order-model.vue"; // 预约洽谈

export default {
  name: "my-collect-topic",
  data() {
    return {
      loading: false, //我联系的加载状态
      finished: false, //我联系的是否完成状态
      list: [], //我联系的列表
      pageIndex: 0,
      pageSize: 20,
      queryThemeFollow: {},
    };
  },
  components: { List, order },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      LinkToHotDetails: "linkTo/LinkToHotDetails",
      delFollowerTopic: "follower/delFollowerTopic",
      delTopice: "my/delTopice",
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList() {
      let query = gql`
        query($query: QueryInput!) {
          exhibitorAppointmentQuery {
            query(query: $query) {
              hasNextPage
              indexFrom
              pageIndex
              pageSize
              items {
                companyUsersId
                content
                createAt
                exhibitionId
                exhibitorId
                langVersion
                id
                customerService {
                  id
                  name
                  nickName
                  phone
                  jobTitle
                  company
                  nameEn
                }
                exhibitor {
                  company {
                    logo
                    name
                    nameEn
                  }
                }
                member {
                  name
                  nickName
                  phone
                  jobTitle
                  company
                  avatarUrl
                }
                memberId
                state
                type
                auditState
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "memberId",
          v: this.userInfo.inMember.memberId,
        },
        EqualA: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualB: {
          n: "state",
          v: 0,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        page: this.pageIndex,
        size: this.pageSize,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("exhibitorAppointmentQuery", {
        query: query,
        variables: {
          query: opt,
          exhibitionId: this.exhibitionId,
          memberId: this.userInfo.inMember.memberId,
          //memberId:this.memberId
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          this.loading = false;
          this.finished = true;

          let res = JSON.parse(JSON.stringify(data.data.exhibitorAppointmentQuery.query));
          // let res=data.data.queryProduct;
          console.log("名片夹", res);
          // let arr = res.items.filter(c=> { // 过滤没有客服信息
          //   return c.customerService;
          // });
          if (this.pageIndex == 1) {
            this.list = res.items;
          } else {
            this.list = [...new Set([...this.list, ...res.items])];
          }
          console.log("this.list", this.list);
          this.loading = false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        },
      });
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      this.getList();
    },
    //取消关注
    async cancelLike(id) {
      let opt = {
        themeId: id,
        memberId: this.userInfo.inMember.memberId,
      };
      let res = await this.delFollowerTopic(opt);
      if (res && res.result) {
        this.list = this.list.filter((item) => item.id != id);
        this.$toast.success("Cancel attention");
      } else {
        this.$toast.fail("Cancellation failed");
      }
    },
    //删除供需
    async delStateNoSupply(id) {
      let res = await this.delTopice(id);
      console.log(res);
      if (res.result) {
        this.list = this.list.filter((item) => item.id != id);
        this.$toast.success("Deletion succeeded");
      } else {
        this.$toast.fail("Deletion failed");
      }
    },
    //重新编辑
    reEdit(item) {
      this.$refs.order.open(item);
      // this.LinkHotSupply(id);
    },
  },
};
</script>

<style scoped lang="scss">
//展品列表
.my_collect_topic {
  .list_wrap {
    .item {
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;
      &:last-child {
        margin-bottom: 0;
      }
      .item_top {
        color: #333;
        display: flex;
        align-items: center;
        padding: 0.2rem 0.2rem 0 0.2rem;
        .logo {
          position: relative;
          width: 0.56rem;
          height: 0.56rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
          }
        }
        p {
          flex: 1;
          font-size: 0.26rem;
          font-weight: 600;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .item_bottom {
        display: flex;
        margin-top: 0.26rem;
        padding: 0 0.2rem 0 0.2rem;
        p {
          font-size: 0.26rem;
          color: #666;
          word-break: break-all;
          span {
            background-color: #d1e9ff;
            border-radius: 4px;
            display: inline-block;
            color: #1890ff;
            text-align: center;
            font-size: 0.2rem;
            padding: 0.03rem 0.08rem;
            margin-right: 0.14rem;
            transform: translateY(-0.02rem);
          }
        }
      }
      .item_state {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .state0 {
          color: #ff9752;
          &.state-1 {
            color: #ff563a;
          }
        }
        .state_no {
          display: flex;
          align-items: center;
          span {
            color: #ff563a;
            margin-right: 0.3rem;
          }
          div {
            padding: 0.05rem 0.2rem;
            border-radius: 0.05rem;
            background: #ff954f;
            color: #fff;
          }
        }
      }
    }
    .item_type {
      border-top: solid 1px #e5e5e5;
      margin-top: 0.26rem;
      font-size: 0.26rem;
      color: #666;
      padding: 0.2rem;
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
